module.exports = __webpack_public_path__ + "static/media/p6preview.76830920.jpg";